const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,isNew,isDeleteView,isOnlyLookupDataUpdate,retriveCriteriaObjectByOperation} from "../../utilities/filtersutil";
import {fixitOrderLookupFieldDropdown} from "./filter/fixitOrderLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html");
let actionCellDropdownItemTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html");
let actionHeaderDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html");
let loadOrderDetailsLinkHtml = require("./html/detailLinkTemplate.html");

let actionList = actionOptions;

const targetSelector = "#fixit-order-lookup-outer";
const addOrderBtn ="#fixit-add-order"; 
let selectedErrDetRows = [];
let selectedData ;

run(targetSelector, ()=>{
	const entryElement = $(targetSelector);
	const dataTableComponentData = entryElement.data("fixit-order-lookup-data");
	const portletNamespace =  $(targetSelector).data("portlet-namespace");
	const savedViews = entryElement.data("saved-views");
	const filterSearchUrl =  $(targetSelector).data("filter-search-url");
	const saveViewURL  =  $(targetSelector).data("save-view-url");
  const deleteViewURL  =  $(targetSelector).data("delete-view-url");
	const detailURL = $(targetSelector).data("fixit-order-detail-url");
	const fixitOrderUrl = entryElement.data("fixit-order-url");
  const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");
	const backToFormUrl = $(targetSelector).data("reload-addOrderform-url"); 

   //Use this url to submit "Bulk Updare" form data info to controller when user clicks on submit button on modal form.
	const bulkUpdateErrorRslUrl = $(targetSelector).data("bulkupdateerrorrslurl-url"); 
  //capture details page url so that it can be used to reload after saving the error.
	const outerLookupLocationUrl = location.href;
	
    let submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();
    let exportModal = new buildExport();
	  const exportUrl = $(targetSelector).data("export-url");
    let targetObject = "";

    if(shouldCheckCache) {
      //targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
      targetObject = retriveFixitCriteriaObjectByOperation(criteriaObjectFromServer, "like");
      
      if(targetObject == null || targetObject == ""){
        //search by IN
        targetObject = retriveFixitCriteriaObjectByOperation(criteriaObjectFromServer, "in");
      }
    }


    //Note: lookup row with empty ReasonCode indicates its header record which does not have any ufix errors yet
    let fixitOrderLookup = new LookupTable({

    target: $("#fixit-order-lookup-wrapper"),
    minWidthClass: "q-min-width-sm-til-md",
    mobileColumns: [
      {
      data: "oreSiteIdDisplay",
      title: "Site ID"
      },
		  {
			data: "oreVzwOrder",
			title: "VZW Order Number",
			render: createDetailLink
		  },
		  {
			data: "oreSapDeliveryNum",
			title: "SAP Delivery Number"
		  },
		  {
			data: "errStatus",
			title: "Status"
		  },
		  {
			data: "oreCreatedDate",
			title: "Date Recieved",
			render: formatCreateDate
		  }

    ],

		tableSearch: true,
    // REQUIRED: search input info
		tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: targetObject != "" ? targetObject.value : ""
    },
		// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: targetObject == "" ? "" : targetObject.key,
      columns: fixitOrderLookupFieldDropdown
    },
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: true,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [{}],
      // Not required, just to show you can
      order: [[3, 'desc']],
      columns: [
        {
          data: "oreId",
		      render: renderActionWrap,
          orderable: false,
		      title: "Actions",
          class: "dtc-action-column"
          //"visible": false
        },
        // {
        //   data: "oreSiteId",
        //   title: "Site ID",
        //   class: "dtc-min-width-sm",
        // },
        {
          data: "oreSiteIdDisplay",
          title: "Site ID",
          class: "dtc-min-width-sm",
          orderable: false
        },
        {
          data: "oreVzwLocation",
          title: "VZW Location",
          class: "dtc-min-width-sm",
          orderable: false
        },
        {
          data: "oreVzwOrder",
          title: "VZW Order",
          class: "dtc-min-width-sm",
		      render: createDetailLink
          ,orderable: false
        },
        {
          data: "oreFscOrder",
          title: "FSC Order",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
        {
          data: "oreSapDeliveryNum",
          title: "SAP Delivery Number",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
        {
          data: "errDesc",
          title: "Reason Code",
          class: "dtc-min-width-sm"  
          ,orderable: false        
        },
        {
          data: "oreSku",
          title: "SKU",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreQty",
          title: "QTY",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreOrderDate",
          title: "Order Date",
          class: "dtc-min-width-sm",
		      render: formatCreateDate
          ,orderable: false
        },	
		{
          data: "oreShipMethod",
          title: "Orig Ship Method",
          class: "dtc-min-width-sm"
          ,orderable: false
        },	
			
		{
          data: "oreAddress1",
          title: "Address1",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreAddress2",
          title: "Address2",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
	  {
          data: "oreCity",
          title: "City",
          class: "dtc-min-width-sm"
          ,orderable: false
    },
		{
          data: "oreState",
          title: "ST",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreZip",
          title: "Zip Code",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
	    {
          data: "oreMdn",
          title: "MDN",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
        
        {
          data: "vzwResolveDate",
          title: "VZW Resolve Date",
          class: "dtc-min-width-sm"
          ,orderable: false
		      //,render: formatCreateDate
        },	
        {
          data: "vzwResolutionDisplay",
          title: "VZW Resolution",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
        {
          data: "lastVzwReslnComment",
          title: "Last VZW Comment",
          class: "dtc-min-width-lg q-break-word"
          ,orderable: false
        },	
        {
          data: "lastVzwReslnCommentOn",
          title: "Last Comment On",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
        {
          data: "lastVzwReslnCommentBy",
          title: "Last Comment By",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreCollateral",
          title: "Collateral Only",
          class: "dtc-min-width-sm",
		      render: formatCollateral
          ,orderable: false
        },
		{
          data: "oreHoldRelease",
          title: "Hold/Release",
          class: "dtc-min-width-sm",
		       render: formatHR
           ,orderable: false
    },
		{
          data: "oreAtp",
          title: "ATP",
          class: "dtc-min-width-sm"
          ,orderable: false
    },

    {
      data: "FscResolutionDisplay",
      title: "FSC Resolution",
      class: "dtc-min-width-sm"
      ,orderable: false
    },
    {
      data: "lastFscComment",
      title: "Last FSC Comment",
      class: "dtc-min-width-sm"
      ,orderable: false
    },    
    {
      data: "lastFscCommentOn",
      title: "Last Comment On",
      class: "dtc-min-width-sm"
      ,orderable: false
    },    
    {
      data: "lastFscCommentBy",
      title: "Last Comment By",
      class: "dtc-min-width-sm"
      ,orderable: false
    },

		{
          data: "orePhoneService",
          title: "Phone Service",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
	    {
          data: "oreMin",
          title: "Min",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreErrorDate",
          title: "Error Date",
          class: "dtc-min-width-sm",
		  render: formatCreateDate
      ,orderable: false
        },		
		{
          data: "oreShippedDate",
          title: "Shipped Date",
          class: "dtc-min-width-sm",
		  render: formatCreateDate
      ,orderable: false
        },
		{
          data: "oreArea",
          title: "Area",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreTypeCode",
          title: "TypeCode",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreSalesId",
          title: "Sales ID",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		{
          data: "oreAppleOrder",
          title: "Apple Ordder",
          class: "dtc-min-width-sm"
          ,orderable: false
        },
		
		// {
    //       data: "oreCreatedDate",
    //       title: "Date Received",
    //       render: formatCreateDate,
    //       class: 'dtc-min-width-sm'
    //     },
	    {
          data: "errStatus",
          title: "Status",
          class: 'dtc-min-width-sm'
          ,orderable: false
        }
      ],
		},
    paginationData:dataTableComponentData.page,

		filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Fixit Orders ",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "fixitOrder"
    },

	onBulkSelectChange: function() {
      const selectedRows = fixitOrderLookup.getBulkSelectedData();
      
    //When user selects two rows, Actions header is enabled and highlighted
     /* $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');        
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');        
      }*/
    },

		onFetch:function() {
			let currentData = fixitOrderLookup.generateData();
			fixitOrderLookup.showLoadingOverlay();
			//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
			if(isOnlyLookupDataUpdate(currentData)){
				setTimeout(() => {
					doAjax({url: filterSearchUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			}else if(isNew(currentData)){
				setTimeout(() => {
					doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			 }else if(isEdit(currentData)){
				setTimeout(() => {
					doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			 }else if(isDeleteView(currentData)){
				 setTimeout(() => {
					doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				 },SUCCESS_MODAL_TIMEOUT);
			 }
		}
  });

	function formateDate(createdDate, type, data) {
		if(createdDate != null && createdDate != ""){
		  var date = moment(createdDate).toDate(); // format yyyy-MM-DD
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var oneDay = 24*60*60*1000;
		  var diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
  }

  function formatCreateDate(createdDate, type, data) {
	if(createdDate != null && createdDate != ""){	
	 var d = new Date(createdDate);
     return  d.toLocaleString();
    }else{
	 return "";	
	}
  }
  
  
   function formatCollateral(collertal, type, data) {
	if(collertal != null && collertal == '1'){	
	 return "Yes";
    }else{
	 return "No";	
	}
   }
   
   function formatHR(rowvalue, type, data) {
	if(rowvalue == 'R'){	
	 return "Release";
    }else{
	 return "Hold";	
	}
  }

	function createDetailLink(data, type, row) {
	let detailPageHTML = `<div class="q-marg-all-xs-at-md">
                        <a href="${detailURL}&${portletNamespace}oreId=${row.oreId}">
                        ${row.oreVzwOrder} </a> </div>`;
	return detailPageHTML;
  }


  function formateDate(dateReceived, type, data){
    if(dateReceived != null && dateReceived != "") {
      let date = new Date(dateReceived);
      let month = date.getMonth() + 1;
      let today = new Date();
      let oneDay = 24*60*60*1000;
      today.setHours(0,0,0,0);
      date.setHours(0,0,0,0);
      let diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
      let friendlyText = "";
      let datePillHTML  = "" ;
      if(diffDays < 100) {
        friendlyText = diffDays.toString() + ' Days Ago';
        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>";
      }
      if(diffDays == 0) {
        friendlyText = 'Today';
      } else if(diffDays== 1) {
        friendlyText ='Yesterday';
      }
      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
    } else {
      return "";
    }
  }

	function filterSuccessFun(data) {
    let fixitOrders = data.content;
    let page = data.page;
    fixitOrderLookup.setNewData(fixitOrders);
    fixitOrderLookup.setPaginationData(page);
    pushFilterSessionCacheState();
	fixitOrderLookup.hideLoadingOverlay();
    setExportData(fixitOrderLookup.generateData());
  }

  function savedViewSuccess(data) {
    let fixitOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    fixitOrderLookup.setNewData(fixitOrders);
    fixitOrderLookup.setPaginationData(page);
    fixitOrderLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    fixitOrderLookup.hideLoadingOverlay();
    setExportData(fixitOrderLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let fixitOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    fixitOrderLookup.setNewData(fixitOrders);
    fixitOrderLookup.setPaginationData(page);
    fixitOrderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    fixitOrderLookup.hideLoadingOverlay();
    setExportData(fixitOrderLookup.generateData());
  }

  function delteViewScussFun(data) {
    let fixitOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    fixitOrderLookup.removeSavedView(data.target);
    fixitOrderLookup.setNewData(fixitOrders);
    fixitOrderLookup.setPaginationData(page);
    fixitOrderLookup.hideLoadingOverlay();
    setExportData(fixitOrderLookup.generateData());
  }

  function errorFun(data) {
    fixitOrderLookup.hideLoadingOverlay();
  }

  fixitOrderLookup.init();

	function shallAllowClick(currentObj) {
		return !$(currentObj).hasClass("disabled");
	}

	$("body").on("click", ".fixit-order", function(e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
      let pIndex = $(this)
        .closest(".dropdown-menu")
        .data("parent-index");
      // Get the row based on the parent...
      let parent = $(".dropdown-parent-" + pIndex).parents("tr");
	  
	  
      // Get the row data
      let row = $(".data-table-component")
        .dataTable()
        .api()
        .row(parent);

      if ($(this).hasClass("fixit-order")) {
        processFixitOrder(row);
      }
    }
  });

  function processFixitOrder(row) {
    const submitModal = new SubmitModalFlow({
      confirmModalTitle: "Fixit Order(s)",
      confirmModalBody: `<div class="q-marg-all-xl">
                          <div class="q-marg-vert-md">
                            Confirming the manual release of this Order(s) will trigger it's original release process.
                          </div>
                          <div class="q-marg-vert-md">
                            Once released, order status will be updated.
                          </div>
                        </div>`,
      confirmModalBtnText: "Release",
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function() {
        submitModal.showLoadingModal();
        let data = row.data();
        releaseOrder(row, data);

        function releaseOrder(row, releaseOrder) {
          $.ajax({
            url: releaseOrderUrl,
            type: "POST",
            dataType: "JSON",
            data: {
              oreId: releaseOrder.oreId
            },
            success: function(data) {
              if (data.response === "success") {
                submitModal.showSuccessModal();
                setTimeout(function() {
                  location.reload();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              } else {
                submitModal.showFailureModal();
              }
            },
            error: function(data) {
              submitModal.showFailureModal();
            }
          });
        }
      }
    });
    submitModal.init();
    submitModal.showConfirmModal();
  }

	function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(actionCellDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row),
      index: meta.row
    });
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionList["all"];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row)
    });
    return newRender;
  }

	function renderActionCellList(list, data, row) {
    let renderedList = _(list).map(item => {
      return render(
        actionCellDropdownItemTemplate,
        neededActions(data, row, item)
      );
    });
    return renderedList.join("");
  }

	function neededActions(data, row, item) {
    let action = {
      icon: item.icon,
      title: item.title,
      cls: item.cls,
      disabled: item.disabled
    };
    return action;
  }

	function initExport() {
    let exportObj  =  {
      title : $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent(portletNamespace);
  }

	function setExportData(currentData) {
    exportModal.buildExportBasicURL(exportUrl,currentData,portletNamespace);
    exportModal.setExportCount(currentData.totalElements);
  }

  initExport();
  setExportData(fixitOrderLookup.generateData());

  handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());

  
  function showAddOrderModal() {
      $("#add-validation-model").modal("show");
  }

  function hideAddOrderModal() {
      $("#add-validation-model").modal("hide");
  }

  // when user clicks on "Bulk Update" button on lookup page after selecting ufix errors,
  // this function will be called and loads bulk resolution update form for user submission.
  $(".btn-bulk-update-modal-call").click(function () {    

  //make sure atleast one row is selected on lookup table.
  const selectedRows = fixitOrderLookup.getBulkSelectedData();
  selectedData = [];
 
  //prepare update request json
    for(let ordDetRow of selectedRows){
      //push only the selected rows which has error associated with it.
      if( ordDetRow.data.errDetId != undefined ){
        selectedData = {
          ufixErrHdrId: ordDetRow.data.ufixErrHdrId,
          ufixErrDetId: ordDetRow.data.errDetId
        }
        selectedErrDetRows.push(selectedData);
      }

      
    }
    
    //show bulk update modal window
    if(selectedErrDetRows.length>0){
      $("#errNote").val("");
      $("#maintain-bulk-update-error-modal").modal("show");
    }else{
      alert("Select atleast one valid row and retry.");
    }
    

  });

  //when user clicks on "Cancel" button on "Bulk Update" form of Lookup page.
  $(".cancel-bulkupdate-modal-btn-with-inputs").click(function (event) {
	  event.preventDefault();
    $("#maintain-bulk-update-error-modal").modal("hide");
    
    //Clear fields
    $("#rslCode").val("DEFAULT");
    $("#errNote").val("");
  });

  //when user clicks on submit button on "Bulk Update" popup form, this function will be called to update the data to ufix
  $(".submit-bulkupdate-btn").click(function (event) {
    let proceed = "true";
    let errResolutionCodeSel =  $("#rslCode").val();
    let errResolutionDescSel =  $("#rslCode option:selected").text();
    let errResolutionNote = ($("#errNote").val()).trim();

    if(errResolutionCodeSel != undefined && errResolutionCodeSel != "DEFAULT" 
      && errResolutionNote  != undefined && errResolutionNote != ""){
        proceed = "true";
        clearErrorOnBulkupdate()
    }else{
        proceed = "false";
        showErrorOnBulkupdate("Please select Resolution Code and provide Resolution comment and try again.");
    }

    if(proceed == "true"){
      var reqData = {
        "rslCode":errResolutionCodeSel,
        "rslDesc":errResolutionDescSel,
        "rslNote":errResolutionNote,
        "bulkErrDetList": selectedErrDetRows
      };

      $.ajax({        
        url: bulkUpdateErrorRslUrl,
        type: 'POST',
        data: {
          bulkUpdateData: JSON.stringify(reqData)
        },
        // beforeSend: function () {
        //   $.blockUI({ message: 'Submitting, Please Wait..' });
        // },
        // complete: function () {
        //   $.unblockUI();
        // },
        dataType: 'JSON',
        async: true,
        success: function(response){
          if(response.status == "SUCCESS" || response.status == "Success"){
            $("#maintain-bulk-update-error-modal").modal("hide");
            submitModalFlow.showLoadingModal();
            
            location.href = outerLookupLocationUrl;
            location.reload();//load the lookup page to display latest data

            setTimeout(function () {
                  submitModalFlow.hideAllModals();
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

            submitModalFlow.showSuccessModal();

          }else{
            showErrorOnBulkupdate(response.errorMessage);
          }
        },error: function (response) {
          submitModalFlow.hideAllModals();
        }
    });
    
    }
    


  });

  function clearErrorOnBulkupdate() {
    $("#bulkupdate-error-div-text").text("");
    $("#bulkupdate-error-div").addClass('hidden');
  }

  function showErrorOnBulkupdate(message){
    $("#bulkupdate-error-div-text").text(message);
    $("#bulkupdate-error-div").removeClass('hidden');
  }

  function retriveFixitCriteriaObjectByOperation(searchCriteria,operationName){
    let targetObj = "";
    let val = "";
    $.each(searchCriteria, function(i, item) {
      if(item.operation == operationName && item.key != "attrValue")
      {
        //remove square braces. they cause issue when page refreshed.
        if((item.value).indexOf('[') >-1){
          val = (item.value).replace('[', '');
          item.value = val;
          if((item.value).indexOf(']') >-1){
            val = (val).replace(']', '');
            item.value = val;
          }
        }
        targetObj = item;
      }
    });
    return targetObj;
  }
});



// WEBPACK FOOTER //
// ./src/pages/fixitOrders/lookup.js